export const PINNED_COMPANIES_KEY = 'pinnedCompanies';
export const PINNED_FUND_INVESTMENTS_KEY = 'pinnedFundInvestments';
export const PINNED_FUNDS_KEY = 'pinnedFunds';
export const PINNED_FIRMS_KEY = 'pinnedFirms';
export const SIDEBAR_ACTIVE_SECTION_KEY = 'sidebarActiveSection';

/** IndexedDB key for a single user's preferences (replaces multi-user localStorage blobs). */
export const preferenceKeyForUser = (baseKey: string, userId: number): string =>
  `${baseKey}:user:${userId}`;

/** Pinned sidebar items: IDs only; labels are resolved at render time. */
export type PinnedItemId = { value: number };

export const normalizePinnedItems = (items: unknown): PinnedItemId[] => {
  if (!Array.isArray(items)) return [];
  return items
    .map(item => {
      if (item && typeof item === 'object' && 'value' in item) {
        const value = Number((item as { value: unknown }).value);
        if (!Number.isNaN(value)) {
          return { value };
        }
      }
      return null;
    })
    .filter((item): item is PinnedItemId => item !== null);
};
